angular.module("screensApp").factory("JackpotService", function ($http, $rootScope) {
  return {
    getJackpotData: function () {
      return $http.get($rootScope.url.TicketURL + "jackpot", { params: { nocache: new Date().getTime() } });
    },
    getJackpotWinners: function (jackpotType) {
      return $http.get($rootScope.url.TicketURL + "JackpotWinners/" + jackpotType, { params: { nocache: new Date().getTime() } });
    }
  };
});
